import { CardData } from '../components/DropdownWegoPro/type';

export const BUSINESS_CARDS: CardData[] = [
  {
    id: 'business_insights',
    title_translation_key: 'business_insights_title',
    description_translation_key: 'business_insights_desc',
    bgColor: '#F3FCFF',
    imageSrc: 'https://zen.wego.com/cms/images/img-business-insights_344870759.png',
    imageSrcAr: 'https://zen.wego.com/cms/images/ar-img-business-insights_344887149.png',
  },
  {
    id: 'expenses_management',
    title_translation_key: 'expenses_management_title',
    description_translation_key: 'expenses_management_desc',
    bgColor: '#FAF2FA',
    imageSrc: 'https://zen.wego.com/cms/images/img-expenses-management_344870769.png',
    imageSrcAr: 'https://zen.wego.com/cms/images/ar-img-expenses-management_344887251.png',
  },
  {
    id: 'business_travel',
    title_translation_key: 'business_travel_title',
    description_translation_key: 'business_travel_desc',
    bgColor: '#E1F0FE',
    imageSrc: 'https://zen.wego.com/cms/images/card-business-travel_344870740.png',
    imageSrcAr: 'https://zen.wego.com/cms/images/ar-card-business-travel_344887281.png',
  },
];
